import type { ConstsRegister } from './declare'
import { constsConfig } from './config'
import constsServers from './services'

class MakeConst {
  consts: { [field: string]: any }

  constructor (config: ConstsRegister) {
    this.consts = {}
    this.register(config)
  }

  register (config: ConstsRegister) {
    for (const [key, value] of Object.entries(config)) {
      value.forEach(({ name, value: data }) => {
        const constName = `${key.toUpperCase()}${constsConfig.sep}${name}`
        this.consts[constName] = data
      })
    }
  }
}

export const consts = new MakeConst(constsServers)
export default consts['consts']